export default "__VITE_ASSET__CHcz7LWW__"